import {
    trigger, state, style, transition, animate, AnimationTriggerMetadata
} from "@angular/animations";

export const squeezeAnimation: AnimationTriggerMetadata = trigger("squeezeAnimation", [
    // Standard use
    state("*", style({

        "max-width": "250px",
        "overflow": "hidden"
    })),
    state("shown", style({

        "max-width": "250px",
        "overflow": "hidden"
    })),
    state("hidden", style({

        "max-width": 0,
        "overflow": "hidden"
    })),
    transition("shown <=> hidden",
        animate("300ms ease")),
    // For use with ngIf
    transition(":enter", [
        style({

            "max-width": 0,
            "overflow": "hidden"
        }),
        animate("300ms", style({

            "max-width": "250px",
            "overflow": "hidden"
        }))
    ]),
    transition(":leave", [
        style({

            "max-width": "200px",
            "overflow": "hidden"
        }),
        animate("300ms", style({

            "max-width": 0,
            "overflow": "hidden"
        }))
    ])
]);
